// The boot entry. The build emits it as its own small chunk, loaded beside the app's entry
// (see vite.config.ts), so these requests leave before the app bundle has been parsed. The reads
// go first: evaluating the chunks' graph would otherwise delay them.
import { startBootReads } from './lib/start-boot-reads';
import { warmWorkspaceAtBoot } from './lib/warm-workspace-at-boot';

startBootReads();
warmWorkspaceAtBoot();
